import { CONFIG } from '@cpd-app/configuration';

/**
 * A11Y.1 (28 Sep rescan), WCAG 1.4.10 Reflow.
 *
 * Via's width was chosen by device type (the user agent), so a desktop window
 * narrowed to 390px (400% zoom at 1280) still got the 470px desktop panel: the
 * page scrolled sideways and the panel was clipped. The width now follows the
 * viewport. Below 960px (the same "small down" the stylesheet and the bottom
 * bar use) Via takes the full width, whatever the device.
 */
export const VIA_FULL_WIDTH_QUERY = '(max-width: 959.98px)';

export function isNarrowViewport(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(VIA_FULL_WIDTH_QUERY).matches
  );
}

export interface ViaPanelSize {
  /** Value for the body's --chat-via-width. */
  width: string;
  /** Whether the body carries .chat-full-screen. */
  fullScreen: boolean;
}

export function viaPanelSize(options: {
  open: boolean;
  isMobile: boolean;
  isNarrow: boolean;
  isFullScreen?: boolean;
  sidebarWidth?: number;
}): ViaPanelSize {
  const {
    open,
    isMobile,
    isNarrow,
    isFullScreen = false,
    sidebarWidth = CONFIG.CHAT_VIA.SIDEBAR_COLLAPSED_WIDTH
  } = options;
  if (!open) {
    return { width: '0px', fullScreen: false };
  }
  if (isMobile || isNarrow) {
    return { width: '100vw', fullScreen: true };
  }
  if (isFullScreen) {
    return { width: 'calc(100vw - var(--sidebar-width))', fullScreen: true };
  }
  return { width: `${CONFIG.CHAT_VIA.WIDTH + sidebarWidth}px`, fullScreen: false };
}

export function applyViaPanelSize(size: ViaPanelSize): void {
  document.body.style.setProperty('--chat-via-width', size.width);
  document.body.classList.toggle('chat-full-screen', size.fullScreen);
}
